import { FEATURE_FLAGS } from '../../../../featureFlags';
import { FRANCHISE_VIEW_PERMISSIONS } from 'dashboard/constants/permissions';
import { frontendURL } from '../../../../helper/URLHelper';
import automations from './automations';
import { routesWithPermissions } from '../../../../routes';
import {
  getUserPermissions,
  hasPermissions,
} from '../../../../helper/permissionsHelper';
import store from '../../../../store';

const getFirstAccessibleAutomationRoute = accountId => {
  const automationItems = automations(accountId).menuItems;
  const userPermissions = getUserPermissions(
    store.getters.getCurrentUser,
    accountId
  );
  const isFeatureEnabledonAccount = (key, flag) =>
    store.getters['accounts/isFeatureEnabledonAccount'](key, flag);

  const accessibleItem = automationItems.find(item => {
    const hasPermission = hasPermissions(
      routesWithPermissions[item.toStateName],
      userPermissions
    );
    const hasFeatureFlag = item.featureFlag
      ? isFeatureEnabledonAccount(accountId, item.featureFlag)
      : true;
    return hasPermission && hasFeatureFlag;
  });

  if (accessibleItem) {
    return {
      toState: accessibleItem.toState,
      toStateName: accessibleItem.toStateName,
    };
  }

  return {
    toState: frontendURL(`accounts/${accountId}/automations/chat-bots/config`),
    toStateName: 'config_chat_bots',
  };
};

const primaryMenuItems = accountId => {
  const automationRoute = getFirstAccessibleAutomationRoute(accountId);
  return [
    {
      icon: 'mail-inbox',
      key: 'inboxView',
      label: 'INBOX_VIEW',
      featureFlag: FEATURE_FLAGS.INBOX_VIEW,
      toState: frontendURL(`accounts/${accountId}/inbox-view`),
      toStateName: 'inbox_view',
    },
    {
      icon: 'chat',
      key: 'conversations',
      label: 'CONVERSATIONS',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toStateName: 'home',
    },
    {
      icon: 'book-contacts',
      key: 'contacts',
      label: 'CONTACTS',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
    },
    {
      icon: 'briefcase',
      key: 'companies',
      label: 'COMPANIES',
      featureFlag: FEATURE_FLAGS.COMPANIES,
      toState: frontendURL(`accounts/${accountId}/companies`),
      toStateName: 'companies_dashboard',
    },
    {
      icon: 'search',
      key: 'flip_leads',
      label: 'FLIP_LEADS',
      featureFlag: FEATURE_FLAGS.FLIP_LEADS,
      toState: frontendURL(`accounts/${accountId}/leads`),
      toStateName: 'flip_leads_search',
    },
    {
      icon: 'building-bank',
      key: 'franchises',
      label: 'FRANCHISES',
      featureFlag: FEATURE_FLAGS.FRANCHISES,
      toState: frontendURL(`accounts/${accountId}/franchises`),
      toStateName: 'franchises_dashboard',
      meta: {
        permissions: ['administrator', FRANCHISE_VIEW_PERMISSIONS],
      },
    },
    {
      icon: 'clipboard-task-list-outline',
      key: 'my_tasks',
      label: 'MY_TASKS',
      toState: frontendURL(`accounts/${accountId}/my_tasks`),
      toStateName: 'my_tasks',
      badgeKey: 'my_tasks',
    },
    {
      icon: 'chat-multiple',
      key: 'internal_chat',
      label: 'INTERNAL_CHAT',
      featureFlag: FEATURE_FLAGS.INTERNAL_CHAT,
      toState: frontendURL(`accounts/${accountId}/internal-chat`),
      toStateName: 'internal_chat',
      // Contador ao lado do rótulo, desenhado pelo AppSidebar (ver `menuBadges` lá).
      badgeKey: 'internal_chat',
    },
    {
      icon: 'kanban',
      key: 'kanban',
      label: 'KANBAN',
      toState: frontendURL(`accounts/${accountId}/kanban`),
      toStateName: 'kanban_board',
      featureFlag: FEATURE_FLAGS.KANBAN_VIEW,
    },
    {
      icon: 'arrow-trending-lines',
      key: 'reports',
      label: 'REPORTS',
      featureFlag: FEATURE_FLAGS.REPORTS,
      toState: frontendURL(`accounts/${accountId}/reports`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'megaphone',
      key: 'campaigns',
      label: 'CAMPAIGNS',
      featureFlag: FEATURE_FLAGS.CAMPAIGNS,
      toState: frontendURL(`accounts/${accountId}/campaigns`),
      toStateName: 'mass_outbound',
    },
    {
      icon: 'flash-settings',
      key: 'automations_nav',
      label: 'AUTOMATIONS_SECTION',
      toState: automationRoute.toState,
      toStateName: automationRoute.toStateName,
    },
    {
      icon: 'library',
      key: 'helpcenter',
      label: 'HELP_CENTER.TITLE',
      featureFlag: FEATURE_FLAGS.HELP_CENTER,
      toState: frontendURL(`accounts/${accountId}/portals`),
      toStateName: 'default_portal_articles',
    },
    {
      icon: 'settings',
      key: 'settings',
      label: 'SETTINGS',
      toState: frontendURL(`accounts/${accountId}/settings`),
      toStateName: 'settings_home',
      meta: {
        permissions: ['administrator', 'custom_role'],
      },
    },
  ];
};

export default primaryMenuItems;
